// extracted by mini-css-extract-plugin
export default {"hoverContainer":"archive_hoverContainer__9uV4I","fileName":"archive_fileName__Bs0Wl","hoverBtn":"archive_hoverBtn__gS5t3","downloadBtn":"archive_downloadBtn__7G0sV"};